export default {
    methods: {
        postalCodeValidation(input) {
            if (!/^\d{10}$/.test(input))
                return false;

            var i;
        for (i = 0; i < 9; ++i) {
            if ( parseInt(input[i]) ==2 )
            return false;
            }

        if(parseInt(input[0]) == parseInt(input[1]))
            if(parseInt(input[1]) == parseInt(input[2]))
                if(parseInt(input[2]) == parseInt(input[3]))
                return false;

    return true;
            }
    }
}